export default __webpack_public_path__ + "static/media/ic_gmx_custom.3d4628ee.svg";